import AccountSummaryPage from "components/pages/AccountSummaryPage";

export default function CaptureExternalTransfersAccountSummary(props) {
    return <AccountSummaryPage />
}